import { BuyerOnboardingWizard } from '../../../../Components/buyers/BuyerOnboardingWizard'

export const BuyerOnboarding = () => <BuyerOnboardingWizard />
